import { F_MapMarkerRouteFragment } from '__generated__v2/graphql';
import { coordsToArrays } from 'libs/utils/3d/3dUtils';
import { isNil, omitBy } from 'lodash';
import { LinePaint } from 'mapbox-gl';
import { EmptyLayer } from 'pages/special/OsloDesignFair/map/markers/view/EmptyLayer';
import { RefObject } from 'react';
import { Layer, MapRef, Source } from 'react-map-gl';
interface Props {
    mapRef: RefObject<MapRef | null>;
    marker: F_MapMarkerRouteFragment;
    beforeId?: string;
    onClick?: (e: MouseEvent) => void;
    orderIndex: number;
}

export const RouteMarker = (props: Props): JSX.Element => {
    const mapRef = props.mapRef;
    const marker = props.marker;
    const markerId = props.marker.id;

    const sourceId = markerId;

    const layerIds = {
        layer: `${markerId}|layer`,
        layerClick: `${markerId}|clickable`,
        last: `${markerId}|last`
    };

    const beforeIds = {
        layer: props.beforeId,
        layerClick: layerIds.layer,
        last: layerIds.layerClick
    };

    const width = marker.width ?? 5;

    if (marker.coordinates.length < 2) {
        return <></>;
    }

    const paintAttributes: LinePaint = {
        'line-color': marker.color,
        'line-width': width,
        'line-opacity': marker.opacity ?? 1
    };

    return (
        <>
            <Source
                key={sourceId}
                id={sourceId}
                type="geojson"
                data={{
                    type: 'Feature',
                    properties: {
                        orderIndex: props.orderIndex,
                        markerId
                    },
                    geometry: {
                        type: 'LineString',
                        coordinates: coordsToArrays(props.marker.coordinates)
                    }
                }}
            >
                <Layer
                    id={layerIds.layer}
                    beforeId={beforeIds.layer}
                    source={sourceId}
                    type="line"
                    paint={{ ...omitBy(paintAttributes, isNil) }}
                    layout={{
                        'line-cap': 'round',
                        'line-join': 'round',
                        visibility: !marker.isHidden ? 'visible' : 'none'
                    }}
                />
                <Layer
                    id={layerIds.layerClick}
                    beforeId={beforeIds.layerClick}
                    source={sourceId}
                    type="line"
                    metadata={{
                        try: 'this'
                    }}
                    paint={{
                        'line-color': 'black',
                        'line-width': Math.max(width, 30),
                        'line-opacity': 0
                    }}
                    layout={{
                        visibility: !props.marker.isHidden ? 'visible' : 'none'
                    }}
                />
                <EmptyLayer id={layerIds.last} beforeId={beforeIds.last} />
            </Source>
        </>
    );
};
